import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Table, Tooltip } from "antd";
import axios from "axios";
import { SubscriptionInfo, UserInfo } from "../../../context";
import { AuditOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import MerchantEmployeeLayout from "../../layout/MerchantEmployeeLayout";
import CreateInventoryReport from "./CreateInventoryReport";
import InventoryReportDetails from "./InventoryReportDetails";

const MerchantEmployeeInvReport = () => {
  const [search, setSearch] = useState("");
  const [productInvReport, setProductInvReport] = useState({
    data: [],
    ready: false,
  });
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const [filteredProduct, setFilteredProduct] = useState([]);
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const columns = [
    {
      title: "Ref #",
      dataIndex: "transaction_id",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Start",
      dataIndex: "start_datetime",
      ellipsis: true,
      render: (text, record) => <p>{moment(text).format("LLL")}</p>,
    },
    {
      title: "End",
      dataIndex: "end_datetime",
      ellipsis: true,

      // align: "center",
      render: (text, record) => <p>{moment(text).format("LLL")}</p>,
    },

    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 40 }}>
          <Tooltip title="Report Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDetailsDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getProductInventoryReport = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      user: "user",
      employee_id: userData.data.id,
    };
    axios
      .get("user/merchant/get/product-inventory-report", { params })
      .then((response) => {
        const data = response.data;
        setProductInvReport({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const getProductList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
        // console.log("FILTERED: ", response.data);
        if (response.data.length > 0) {
          setFilteredProduct(
            response.data.map((item) => ({
              id: item.id,
              product: item.product,
              quantity: "",
              available: item.quantity,
            }))
          );
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getProductInventoryReport();
    getProductList();
  }, [getProductInventoryReport, getProductList]);

  const searchable = productInvReport.data.filter((data) => {
    return data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  //   const handleOk = () => {
  //     setConfirmLoading(true);
  //     setTimeout(() => {
  //       setDeleteDialog(false);
  //       setConfirmLoading(false);
  //       handleDeleteCustomerOrder();
  //     }, 2000);
  //   };

  //   const handleDeleteCustomerOrder = () => {
  //     const formdata = new FormData();
  //     formdata.append(
  //       "user_id",
  //       userData.data.usersmerchantemployee.merchant_user_id
  //     );
  //     formdata.append(
  //       "transaction_id",
  //       selectedData !== null ? selectedData.transaction_id : ""
  //     );
  //     // setLoadings(true);
  //     axios
  //       .post("user/merchant/delete-customer-order", formdata)
  //       .then((response) => {
  //         const data = response.data;
  //         if (data === "success") {
  //           rerunNotif("success", "Delete order successfully.");
  //           setTimeout(() => {
  //             // setLoadings(false);
  //             rerunCustomerOrders();
  //           }, 1000);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("Error: ", error);
  //         // setLoadings(false);
  //       });
  //   };

  //   console.log("filteredProduct: ", filteredProduct);

  return (
    <MerchantEmployeeLayout>
      <div
        style={{
          overflowX: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search ref #"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
          disabled={filteredProduct.length < 1}
        >
          Add Report
        </Button>
      </div>

      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={searchable.length > 0 ? searchable : []}
        scroll={scroll}
        rowKey={(record) => record.id}
      />

      {openDrawer && (
        <CreateInventoryReport
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          getProductInventoryReport={() => getProductInventoryReport()}
          productList={
            productList.ready && productList.data.length > 0
              ? productList.data
              : []
          }
          filteredProduct={filteredProduct.length > 0 && filteredProduct}
        />
      )}

      {openDetailsDrawer && (
        <>
          {selectedData !== null && (
            <InventoryReportDetails
              open={openDetailsDrawer}
              close={() => setOpenDetailsDrawer(false)}
              selectedData={selectedData}
            />
          )}
        </>
      )}

      {/* <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      /> */}

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        //   open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeInvReport;
